// PrivateRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";

const hasValidToken = () => {
  const token = localStorage.getItem("access");
  if (!token) return false;
  const t = String(token).trim().toLowerCase();
  return t !== "" && t !== "null" && t !== "undefined";
};

const getUserRole = () => (localStorage.getItem("role") || "").toLowerCase();
const landingForRole = (role) => role === "company" ? "/company/dashboard" : role === "crew" ? "/crewdash" : "/dashboard";

/**
 * Usage:
 *  <PrivateRoute exact path="/dashboard" component={Dashboard} crewRedirect />   // crew goes to /crewdash
 *  <PrivateRoute exact path="/crewdash" component={CrewProfile} />              // no redirect here
 */
const PrivateRoute = ({ component: Component, crewRedirect = false, allowedRoles, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!hasValidToken()) return <Redirect to="/login" />;

      const role = getUserRole();
      if (allowedRoles && !allowedRoles.includes(role)) {
        return <Redirect to={landingForRole(role)} />;
      }
      // Only redirect crews if this route opted in via `crewRedirect`
      // and we're NOT already on the destination (/crewdash)
      if (
        crewRedirect &&
        role === "crew" &&
        props.location.pathname !== "/crewdash"
      ) {
        return <Redirect to="/crewdash" />;
      }
      if (crewRedirect && role === "company" && !props.location.pathname.startsWith("/company")) {
        return <Redirect to="/company/dashboard" />;
      }

      return <Component {...props} />;
    }}
  />
);

export default PrivateRoute;
